import { useSessionStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'

export const season = useSessionStorage(buildDropeeStorageKey('season'), '')

export function initSeason() {
  const searchParams = new URLSearchParams(window.location.search)
  const seasonParam = searchParams.get('season')
  if (!seasonParam) return
  season.value = seasonParam
}
